// src/AdminRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './AuthContext'; // Adjust path as needed
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';

function AdminRoute() {
    const { user, loading } = useAuth();

    if (loading) {
        // Show loading indicator while checking auth status
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                <CircularProgress />
            </Box>
        );
    }

    // IMPORTANT: Assumes your 'user' object from useAuth()
    // now includes an 'isAdmin' boolean property after successful login/status check.
    // You need to modify your backend /auth/status endpoint and AuthProvider
    // to include this role information.
    if (!user?.isAuthenticated || !user?.isAdmin) {
        // Redirect non-admins to the home page or show an access denied message
        // Option 1: Redirect
        return <Navigate to="/" replace />;

        // Option 2: Show message (less user-friendly for direct access attempts)
        // return (
        //   <Box sx={{ p: 4 }}>
        //     <Alert severity="error">Access Denied. You do not have permission to view this page.</Alert>
        //   </Box>
        // );
    }

    // If authenticated and is admin, render the child route (Outlet)
    return <Outlet />;
}

export default AdminRoute;
